var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className,style:({ height: _vm.height, width: _vm.width }),attrs:{"datas":_vm.datas,"title":_vm.title,"id":_vm.id,"labelfontsize":_vm.labelfontsize}})
}
var staticRenderFns = []

export { render, staticRenderFns }